import { UserRole } from '../services/api/sharedTypes/User'

export const getUserRoleName = (role: UserRole) => {
    switch (role) {
        case UserRole.Admin:
            return 'Admin'
        case UserRole.User:
            return 'Uživatel'
        case UserRole.NotSet:
            return ''
    }
}
